import * as fromDatatype from "../datatype-library/index";

export interface bl_aat_claim_approval_delegation_period_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  main_employee_hdr_guid: fromDatatype.GuidDataFieldInterface;
  delegated_employee_hdr_guid: fromDatatype.GuidDataFieldInterface;
  delegated_login_subject_guid: fromDatatype.GuidDataFieldInterface;
  delegation_start_date: fromDatatype.TimestampTzDatatypeInterface;
  delegation_end_date: fromDatatype.TimestampTzDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}

export class bl_aat_claim_approval_delegation_period_RowClass
  implements bl_aat_claim_approval_delegation_period_RowInterface
{
  guid: fromDatatype.GuidDataFieldInterface;
  main_employee_hdr_guid: fromDatatype.GuidDataFieldInterface;
  delegated_employee_hdr_guid: fromDatatype.GuidDataFieldInterface;
  delegated_login_subject_guid: fromDatatype.GuidDataFieldInterface;
  delegation_start_date: fromDatatype.TimestampTzDatatypeInterface;
  delegation_end_date: fromDatatype.TimestampTzDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}
